import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AgentGroupDTO, AgentStatsDTO } from '@app/control-panel/models/control-panel.model';

@Component({
  selector: 'scf-agent-statistic-table',
  templateUrl: './agent-statistic-table.component.html',
  styleUrls: ['./agent-statistic-table.component.scss'],
})
export class AgentStatisticTableComponent implements OnInit, AfterViewInit {
  @Input() data: AgentGroupDTO;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isTableHidden: boolean = false;

  isFirstPage: boolean = true;
  isLastPage: boolean = false;
  page: number = 0;

  //Variable needed for table order of columns
  displayedColumns: string[] = [
    'agent',
    'nameAgent',
    'numOperation',
    'investment',
    'TIR',
    'PI',
    'totalCommissionAgent',
    'percentageCommission',
    'totalCommission',
  ];

  public dataRow: string[] = [
    //Name of columns
    'AGENTE',
    'NOMBRE',
    'NºOPERAC',
    'INVERSIÓN',
    'TIR MEDIA',
    'Pl.MEDIO ',
    'TOT.COMI.AGENTE',
    '%COMIS.',
    'TOTAL COMISIONES',
  ];

  dataSource = new MatTableDataSource<AgentStatsDTO>();
  //totals: InvestDetailOperationTotals;

  constructor(private cdref: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.dataSource.data = this.data?.items;
  }

  displayCard(): void {
    this.isTableHidden = !this.isTableHidden;
    this.cdref.detectChanges();
    this.dataSource.paginator = this.paginator;
  }

  savePage(event: any): void {
    this.page = event?.pageIndex;
  }
}
